import { LogisticaGuiaEstado } from "@pcgerente-node/pcg-comun"
import React from "react"
import { BsClipboardCheckFill } from "react-icons/bs"; //Recibido
import { GiReturnArrow } from "react-icons/gi"; //Devuelto
import anulada from "../../../../assets/img/anulada.png"
import enPlantaImg from "../../../../assets/img/en-planta.png"
import enRutaImg from "../../../../assets/img/en-ruta.png"
import entregadoImg from "../../../../assets/img/entregado.png"
import enviadoImg from "../../../../assets/img/enviado.png"
import recibidoBodegaImg from "../../../../assets/img/recibido-bodega.png"
import "./BannerEstado.css"
interface ChildProps{
    estadoGuia: string
}

const StyleImg: React.CSSProperties = {
    height: "50px",
    margin: "0 3px"
}

const BannerEstadosGuias: React.FC<ChildProps> = ({estadoGuia}) => {
    return(
        <div className="justify-content-center d-flex align-items-center mt-2">
            <div className={ObtenerEstilo(LogisticaGuiaEstado.Planta, "img")}><img style={StyleImg} src={enPlantaImg} alt="En Planta" title="En Planta"/> </div>
            <div className={ObtenerEstilo(LogisticaGuiaEstado.Recibido, "svg")}><BsClipboardCheckFill title="Recibido"/></div> {/*Recibido*/}
            <div className={ObtenerEstilo(LogisticaGuiaEstado.Viaje, "img")}><img style={StyleImg} src={enviadoImg} alt="Enviado" title="Enviado"/> </div>
            <div className={ObtenerEstilo(LogisticaGuiaEstado.RecibidoEnBodegaTransito, "img")}><img style={StyleImg} src={recibidoBodegaImg} alt="En bodega" title="En bodega"/> </div>
            <div className={ObtenerEstilo(LogisticaGuiaEstado.Ruta, "img")}><img style={StyleImg} src={enRutaImg} alt="En ruta" title="En ruta"/> </div>
            <div className={ObtenerEstilo(LogisticaGuiaEstado.Entregada, "img")}><img style={StyleImg} src={entregadoImg} alt="Entregada" title="Entregada"/> </div>
            <div className={ObtenerEstilo(LogisticaGuiaEstado.Devuelta, "svg")}><GiReturnArrow title="Devuelta"/></div> {/*Devuelta*/}
            <div className={ObtenerEstilo(LogisticaGuiaEstado.Anulado, "img")}><img style={StyleImg} src={anulada} alt="Anulada" title="Anulada"/> </div>
        </div>
    )

    function ObtenerEstilo(estado: LogisticaGuiaEstado, type: "img"|"svg"): string{
        if(estado === estadoGuia ){
            if(type === "img"){
                return "img-banner-estado-on"
            }else{
                return "svg-banner-estado-on"
            }
        }else{
            if(type === "img"){
                return "img-banner-estado-off"
            }else{
                return "svg-banner-estado-off"
            }
        }
    }
}
export default BannerEstadosGuias